import React from 'react';
import { Stack, Text, Button } from '@moda/om';

import './ContactToPurchaseSuccessMessage.scss';

type Props = { onClose: () => void };

export const ContactToPurchaseSuccessMessage: React.FC<Props> = ({ onClose }) => {
  return (
    <Stack space={5}>
      <Stack space={4}>
        <Text className="ContactToPurchaseSuccessMessage__title" treatment="h3" family="serif">
          We've Received Your Inquiry
        </Text>
        <Text className="ContactToPurchaseSuccessMessage__description">
          A member of our team will review your details and get back to you shortly.
        </Text>
      </Stack>
      <Button className="ContactToPurchaseSuccessMessage__button" onClick={onClose}>
        Done
      </Button>
    </Stack>
  );
};
